module.exports = __webpack_public_path__ + "components/forecast-table/tooltips/static/rainfall-73092f1ecad893748af3da03ab17358f.jpg";